import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FiPlusCircle } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { getTrainingManagementStatusClass, tabType, TM_STATUS } from "../CONSTANTS";
import TrainingBatchTab from "./Component/TrainingBatchTab";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { useArea, useCategory } from "app/_helpers/hooks";
import { filterActionAdd } from "./ReducerForAssign";
import { isUserVTO } from "../../IncidentManagement/Helper";
import { Validation } from "app/_helpers/validation/Validation";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import {
  TRAINING_STATUS,
  TRAINEE_TYPE,
  TRAINING_TYPE,
  TRAINING_TYPE_VIEW,
  trainingScheduleFilterFields,
} from "../CONSTANTS";
import {
  allTrainingAssignersCount,
  createTrainingBatch,
  getAllTrainingAssigners,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import { FaRegEdit } from "react-icons/fa";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import TrainingScheduleFilters from "./Component/TrainingScheduleFilters";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import { getEmployee } from "app/_services/UserManagement/EmployeeService";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

const initialFilter = { status: "due", traineeType: "all" };

const initialBatchForm = {
  traineeIds: [],
  centerName: "",
  centerCode: "",
  duration: "",
  trainingDate: "",
  trainingCategory: "",
  trainingSubCategory: "",
  areaId: null,
  trainingId: "",
  batchId: "",
};

const rules = [
  {
    field_name: "centerName",
    label: "Name of Center",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "centerCode",
    label: "Center Code",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "duration",
    label: "Duration",
    type: "number",
    nonNegative: true,
    isRequired: true,
  },
  {
    field_name: "trainingDate",
    label: "Date of Training",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainingCategory",
    label: "Category",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainingSubCategory",
    label: "Sub Category",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "areaId",
  //   label: "Area Of Operation",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "trainingId",
  //   label: "Training ID",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "batchId",
    label: "Batch ID",
    type: "string",
    isRequired: true,
  },
];

const TRAINING_SCHEDULE_OPTION = [
  {
    label: "I",
    id: "I",
  },
  {
    label: "IV",
    id: "IV",
  },
];

export const TRAINING_SESSION_OPTION = [
  {
    label: "Morning (M)",
    id: "morning",
  },
  {
    label: "Evening (E)",
    id: "evening",
  },
  {
    label: "Morning & Evening (M & E)",
    id: "both",
  },
];

export const SelectAllHeader = ({
  onSelectAll,
  onSort,
  selectAllRef,
  tableContainerRef,
}) => {
  const classNameRef = useRef("order-4 pointer");
  const handleSort = useCallback(() => {
    const th = tableContainerRef.current?.querySelector(
      '.react-bootstrap-table table thead tr th[data-row-selection="true"]'
    );
    const span = th?.querySelector("span");

    if (!span?.className) return;

    const order =
      span.className.includes("order-4") || span.className.includes("caret-4-desc")
        ? "asc"
        : "desc";

    classNameRef.current = `caret-4-${order} pointer`;
    span.className = classNameRef.current;

    onSort({
      order,
    });
  }, [onSort, tableContainerRef]);

  const handleChange = useCallback(
    (event) => {
      onSelectAll(event.target.checked);
      selectAllRef.current = event.target.checked;
    },
    [onSelectAll, selectAllRef]
  );

  useEffect(() => {
    const run = () => {
      const th = tableContainerRef.current?.querySelector(
        '.react-bootstrap-table table thead tr th[data-row-selection="true"]'
      );
      if (!th) return;

      if (th.firstElementChild) {
        th.firstElementChild.checked = selectAllRef.current;
        th.firstElementChild.onchange = handleChange;
        th.firstElementChild.nextElementSibling.className = classNameRef.current;
        th.firstElementChild.nextElementSibling.onclick = handleSort;
        return;
      }

      const input = document.createElement("input");
      input.type = "checkbox";
      input.checked = selectAllRef.current;
      input.onchange = handleChange;
      const span = document.createElement("span");
      span.className = classNameRef.current;
      span.onclick = handleSort;

      th.innerHTML = "";
      th.appendChild(input);
      th.appendChild(span);
    };

    run();

    const timer = setInterval(run, 1000);

    return () => clearInterval(timer);
  });

  return null;
};

const approveStatusByType = (type) => {
  switch (type) {
    case TRAINING_STATUS.scheduled:
      return TRAINING_STATUS.soReview;

    case TRAINING_STATUS.soReview:
      return TRAINING_STATUS.mmReview;

    case TRAINING_STATUS.mmReview:
      return TRAINING_STATUS.completed;

    default:
      break;
  }
};

const Assign = ({
  match: {
    params: { siteId },
  },
}) => {
  //get status state
  const filterStatus = useSelector((state) => state.filterReducerTraining);

  // set status fun
  const dispatchFunction = useDispatch();

  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 2);
  const [trainings, setTrainings] = useState([]);
  const [filter, setFilter] = useState(() => {
    const state = {
      ...(filterStatus?.assignFilter.status ? filterStatus?.assignFilter : initialFilter),
    };

    if (!state.traineeType) state.traineeType = "all";

    return state;
  });
  const [tableVFLList, setTableVFLList] = useState([]);
  const [error, setError] = useState({ ...initialBatchForm });
  const [selectedTraining, setSelectedTraining] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [category, categoryOption] = useCategory("filter[source]=training");
  const [form, setForm] = useState({ ...initialBatchForm });
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [showFilterBtn, setShowFilterBtn] = useState(true);
  const [tabCount, setTabCount] = useState({});
  const [employeeList, setEmployeeList] = useState([]);
  const [contractorStaffList, setContractorStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const onReset = () => setFilterForm({});

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // useEffect(() => {
  //   getEmployee().then((response) => {
  //     setEmployeeList(response?.data?.employees || []);
  //   });

  //   getAllContractorPerson().then((response) => {
  //     setContractorStaffList(response?.data || []);
  //   });
  // }, []);

  const tabCountFun = useCallback(async () => {
    const obj = {};
    const response = await allTrainingAssignersCount();
    obj["2"] = response?.data?.basicTraining || 0;
    obj["3"] = response?.data?.newBasicTraining || 0;
    obj["4"] = response?.data?.refreshTraining || 0;
    setTabCount(obj);
  }, []);

  useEffect(() => {
    tabCountFun();
  }, [tabCountFun]);

  useEffect(() => {
    setShowFilterBtn(true);
  }, [tab]);

  const subcategoryOption = useMemo(
    () =>
      (category.find((x) => x.id === form.trainingCategory)?.subCategory || []).map(
        (d) => ({ label: d.name, id: d.id })
      ),
    [category, form.trainingCategory]
  );

  useEffect(() => {
    // set status in redux store

    dispatchFunction(filterActionAdd({ assignFilter: filter }));
  }, [filter]);

  //
  const apiFilter = `${siteId ? "&filter[siteId]=" + siteId : ""}`;

  const initialData = useCallback(async () => {
    getAllTrainingAssigners(tabType[tab]).then((response) => {
      if (!response?.data) return;

      setTrainings(
        Array.isArray(response?.data)
          ? response?.data
              // ?.filter(
              //   (d) =>
              //     d?.trainingStatus == TRAINING_STATUS.due ||
              //     d?.trainingStatus == TRAINING_STATUS.overDue
              // )
              ?.map((d, index) => {
                // let objData = {};
                // if (d?.traineeType === "employee") {
                //   objData = employeeList?.find((obj) => obj?.id === d?.traineeId);
                // } else if (d?.traineeType === "contractorPerson") {
                //   objData = contractorStaffList?.find((obj) => obj?.id === d?.traineeId);
                // }
                return {
                  ...d,
                  sid: index + 1,
                  // traineeID: objData ? objData?.srNo || objData?.employeeId : "",
                  // traineeName: objData
                  //   ? `${objData?.firstName} ${objData?.lastName}`
                  //   : "",
                  // formA: objData
                  //   ? objData?.contractorFormA?.serialNumberOmc ||
                  //     objData?.employeeFormA?.serialNumberOmc
                  //   : "",
                };
              })
          : []
      );
      setLoading(false);
    });
  }, [tab]);

  const onChangeBatch = ({ target: { name, value, type, checked } }) => {
    setForm((prevForm) => {
      const updates = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      const extraToChange = changeDependentDropdown(name, value);

      return { ...updates, ...extraToChange };
    });
  };

  // const onSelectAll = ({ target: { name, value, type, checked } }) => {
  //   setSelectedTraining(checked);
  //   setTableVFLList([]);

  //   setForm((prev) => ({
  //     ...prev,
  //     trainingType: tableVFLList[0]?.trainingType,
  //     ehsSiteId: tableVFLList[0]?.ehsSite?.name,
  //   }));

  //   if (!checked) return setSelectedTraining([]);
  //   setSelectedTraining(
  //     tableVFLList
  //       .filter((row) => row.trainingStatus === TRAINING_STATUS.due)
  //       .map((d) => d.id)
  //   );
  // };

  /*****************************Dependent Data Function ****************/
  const changeDependentDropdown = (name, value) => {
    switch (name) {
      case "trainingCategory":
        if (form.trainingCategory !== value) return { trainingSubCategory: "" };
        break;
      default:
        return {};
    }
  };

  //
  const addToBatch = () => {
    if (!selectedTraining.length)
      return toastr.info("Please Select at least one training");

    setShowModal(true);
  };

  // const onChangeTraining = useCallback(
  //   ({ target: { name, value, checked } }, extraToUpdate) => {
  //     setTableVFLList([]);

  //     value = +value;

  //     if (checked && !selectedTraining.includes[value]) {
  //       setSelectedTraining((previous) => [...previous, value]);
  //     } else if (selectedTraining.includes(value)) {
  //       setSelectedTraining((previous) => [
  //         ...previous.filter((id) => id !== value),
  //       ]);
  //     }

  //     setForm((prev) => ({ ...prev, ...extraToUpdate }));
  //   },
  //   [selectedTraining]
  // );

  // const onChange = ({ target: { name, value } }) => {
  //   setFilter((prev) => ({ ...prev, [name]: value }));
  //   setSelectedTraining([]);
  // };

  const tableToolbarView = () => (
    <CustomTooltip tooltip={"Assign Training"}>
      <Link
        className="icons btn-icon font-20 text-cyanBlue"
        to={`${
          siteId ? `/sites/${siteId}` : ""
        }/health-safety-and-environment/training-management/assign/assign-new-training`}
      >
        <FiPlusCircle />
      </Link>
    </CustomTooltip>
  );

  const [sort, setSort] = useState({ order: "asc", dataField: "" });

  const handleOnSelect = useCallback((row, isSelect) => {
    selectAllRef.current = false;
    // console.log("row++++++++++", row);
    // console.log("isSelect++++++++", isSelect);

    if (isSelect) {
      setSelectedTraining((prev) => [...prev, row.id]);

      setForm((prev) => ({
        ...prev,
        trainingType: row?.trainingType,
        ehsSiteId: row?.ehsSite?.name,
        schedule: TRAINING_TYPE.refreshTraining === row?.trainingType ? "IV" : "I",
      }));
    } else {
      setSelectedTraining((prev) => prev.filter((x) => x !== row.id));
    }
  }, []);

  const tableContainerRef = useRef(null);
  const selectAllRef = useRef(false);

  const onTableChange = (actionType, { sortField: dataField, sortOrder: order }) => {
    if (actionType !== "sort") return;

    setSort({ dataField, order });
    setTableVFLList((prev) => {
      const newRows = [...prev].sort((a, b) => {
        if (order === "asc") return a[dataField] > b[dataField] ? -1 : 1;
        else return a[dataField] < b[dataField] ? -1 : 1;
      });

      return newRows;
    });
  };

  const handleOnSelectAll = useCallback(
    (isSelect) => {
      selectAllRef.current = isSelect;
      if (isSelect) {
        const ids = tableVFLList.map((r) => r.id);
        setSelectedTraining(ids);
        setForm((prev) => ({
          ...prev,
          trainingType: tableVFLList[0]?.trainingType,
          ehsSiteId: tableVFLList[0]?.ehsSite?.name,
        }));
      } else {
        setSelectedTraining([]);
      }
    },
    [tableVFLList]
  );

  const onChangeTab = useCallback(
    (value) => {
      if (tab !== value) {
        setTab(value);
        setTableVFLList([]);
        setTrainings([]);
        setFilter({ ...initialFilter });
        setSelectedTraining([]);
        selectAllRef.current = false;
      }
    },
    [tab]
  );

  // ************* Submit ********
  const onSubmit = useCallback(async () => {
    const errorObj = Validation(form, rules);

    setError(errorObj);

    if (Object.values(errorObj).filter((d) => d !== "").length) return;
    const formData = {
      ...form,
      traineeIds: [...selectedTraining],
    };

    let response = await createTrainingBatch(formData);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");
    initialData();
    setShowModal(false);
    setSelectedTraining([]);
    // history.push(`/health-safety-and-environment/vfl`);
  }, [form, initialData, selectedTraining]);

  const onSubmitApproveReject = useCallback(
    async (obj, extraObj) => {
      const result = await updateAssignersStatus(obj);

      if (result?.status) {
        toastr.success(result?.message || "Success");

        initialData();
      }
    },
    [initialData]
  );

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "siteName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "traineeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      // {
      //   dataField: "traineeDesignation",
      //   text: "Designation",
      //   sort: true,
      // },
      // {
      //   dataField: "trainingTypeView",
      //   text: "Training Type",
      //   sort: true,
      // },
      // {
      //   dataField: "trainingCategoryName",
      //   text: "Skill Category",
      //   sort: true,
      // },
      {
        dataField: "dueDateView",
        text: "Due Date",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
      // {
      //   dataField: "trainingSubCategoryName",
      //   text: "Training Sub-Category",
      //   sort: true,
      // },

      // {
      //   dataField: "startDate",
      //   text: "Date of Training",
      //   sort: true,
      // },
      // {
      //   dataField: "trainingStatusView",
      //   text: "Status",
      //   sort: true,
      // },
      // {
      //   dataField: "Certificate",
      //   text: "Certificate",
      //   sort: true,
      //   formatter: (id, row) => {
      //     return (
      //       <div className="actionIconsGroup">
      //         {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() && (
      //           <CustomTooltip tooltip={"Certificate"}>
      //             <a href={"/health-safety-and-environment/training-management/certificate/" + row?.id} target="_blank" rel="noopener noreferrer" className="icons text-cyanBlue">
      //               <FiInfo style={{ color: "rgb(21 239 21)" }} />
      //             </a>
      //           </CustomTooltip>
      //         )}
      //       </div>
      //     );
      //   },
      // },

      {
        dataField: "ID",
        text: "Action",
        formatter: (cell, row) => {
          return (
            <div className="actionIconsGroup">
              <DeleteRecordIcon
                id={row.id}
                moduleType={moduleType.ehsTrainingAssigners}
                setLoading={setLoading}
                reloadData={initialData}
              />
            </div>
          );
        },
      },
    ];

    return column;
  }, [initialData]);

  const onSortSelection = useCallback(
    (sort) => {
      setSort({
        order: sort.order,
        dataField: "_selection",
      });
      setTableVFLList((prev) => {
        const newRows = [...prev].sort((a, b) => {
          if (selectedTraining.includes(sort.order === "asc" ? a.id : b.id)) return -1;

          return 1;
        });

        return newRows;
      });
    },
    [selectedTraining]
  );

  // const selectionHeaderRenderer = useCallback(({ checked }) => <SelectAllHeader checked={checked} onSelectAll={handleOnSelectAll} onSort={onSort} />, [handleOnSelectAll]);

  const selectRow = useMemo(
    () => ({
      mode: "checkbox",
      clickToSelect: true,
      hideSelectAll: true,
      selected: selectedTraining,
      onSelect: handleOnSelect,
      // selectionHeaderRenderer: selectionHeaderRenderer,
    }),
    [handleOnSelect, selectedTraining]
  );

  // ******** Use Effect ******
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  useEffect(() => {
    let trainingType = null;
    switch (tab) {
      case 2:
        trainingType = TRAINING_TYPE.basicTraining;
        break;
      case 3:
        trainingType = TRAINING_TYPE.newBasicTraining;
        break;
      case 4:
        trainingType = TRAINING_TYPE.refreshTraining;
        break;
      case 5:
        trainingType = TRAINING_TYPE.other;
        break;
      default:
        break;
    }

    setTableVFLList(
      trainings
        //?.filter((d) => !trainingType || d.trainingType === trainingType)
        ?.filter((data) => {
          let flag = true;
          if (filterForm?.traineeTypeView === "All") flag = true;

          if (flag) {
            for (const key in filterForm) {
              if (
                (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
                !filterForm[key]
              )
                continue;
              if (data[key] !== filterForm[key]) return (flag = false);
            }

            return (flag = true);
          }

          // if (flag) flag = validateRowFilter(filterForm, data);
          return flag;
        })
    );
  }, [filterForm, tab, trainings]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingScheduleFilters
        fields={trainingScheduleFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  const batchButtonView = () =>
    tab !== 6 &&
    [2, 3, 4].includes(tab) &&
    isUserVTO() &&
    selectedTraining.length > 0 && (
      <>
        {filter.status === TRAINING_STATUS.due && (
          <Button onClick={addToBatch} style={{ marginRight: 20, paddingBottom: "2px" }}>
            Create Batch
          </Button>
        )}

        {[
          TRAINING_STATUS.scheduled,
          TRAINING_STATUS.soReview,
          TRAINING_STATUS.mmReview,
        ].includes(filter.status) && (
          <Button
            onClick={() => {
              onSubmitApproveReject({
                assigneeIds: selectedTraining,
                trainingStatus: approveStatusByType(filter?.status),
              });
            }}
            style={{ marginRight: 30 }}
          >
            Approve
          </Button>
        )}
      </>
    );

  // useEffect(() => {
  //   const obj = {};
  //   obj["2"] = trainings?.filter(
  //     (d) => d.trainingType === TRAINING_TYPE.basicTraining
  //   )?.length;
  //   obj["3"] = trainings?.filter(
  //     (d) => d.trainingType === TRAINING_TYPE.newBasicTraining
  //   )?.length;
  //   obj["4"] = trainings?.filter(
  //     (d) => d.trainingType === TRAINING_TYPE.refreshTraining
  //   )?.length;
  //   setTabCount(obj);
  // }, [trainings]);

  // console.log("tableVFLList", tableVFLList);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          {
            name: "Health Safety And Environment",
            path: "#",
          },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "Schedule Training" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          {/* <label>here</label> */}
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            <a
              className={`${tab === 2 ? "active" : ""}`}
              href
              onClick={() => onChangeTab(2)}
            >
              Basic Training ({tabCount["2"]})
            </a>
            <a
              className={`${tab === 3 ? "active" : ""}`}
              href
              onClick={() => onChangeTab(3)}
            >
              New Basic Training ({tabCount["3"]})
            </a>
            <a
              className={`${tab === 4 ? "active" : ""}`}
              href
              onClick={() => onChangeTab(4)}
            >
              Refresher Training ({tabCount["4"]})
            </a>
            <a
              className={`${tab === 5 ? "active" : ""}`}
              href
              onClick={() => onChangeTab(5)}
            >
              Other Training
            </a>
            <a
              className={`${tab === 6 ? "active" : ""}`}
              href
              onClick={() => onChangeTab(6)}
            >
              Batches Details
            </a>
          </div>
        </div>

        {tab === 5 ? (
          <div className="manageBtnScreen">
            <Row>
              <Col lg={4}>
                <Link
                  to={
                    "/health-safety-and-environment/training-management/assign/assign-new-training"
                  }
                  className="btn manage-btn"
                >
                  <FaRegEdit />
                  Add Other Training
                </Link>
              </Col>
            </Row>
          </div>
        ) : (
          <div className="p-2">
            <div className="card p-3 mt-3" ref={tableContainerRef}>
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-1">
                  {/* {tab === 2 ? "Basic Training" : tab === 3 ? "New Basic Training" : tab === 4 ? "Refresher Training" : tab === 5 ? "Other Training" : "Batches Details"} */}
                  {tab === 6 ? "Batches Details" : "Schedule Training"}
                </h3>
                {showFilterBtn && <FilterBtn setShowFilter={setShowFilter} />}
                {/* <ShowActiveModules module={ACTIVE_MODULE.training} /> */}

                <BackBtn url="/health-safety-and-environment/training-management" />
              </div>

              {/* {tab !== 6 && (
                <Row className="searchIncident" style={{ border: "0", paddingTop: "0" }}>
                  <Col lg={10}></Col>
                  <Col lg={2}>
                    {[2, 3, 4].includes(tab) && isUserVTO() && (
                      <>
                        {selectedTraining.length > 0 && (
                          <>
                            {filter.status === TRAINING_STATUS.due && (
                              <Button onClick={addToBatch}>Create Batch</Button>
                            )}

                            {[
                              TRAINING_STATUS.scheduled,
                              TRAINING_STATUS.soReview,
                              TRAINING_STATUS.mmReview,
                            ].includes(filter.status) && (
                              <Button
                                onClick={() => {
                                  onSubmitApproveReject({
                                    assigneeIds: selectedTraining,
                                    trainingStatus: approveStatusByType(filter?.status),
                                  });
                                }}
                              >
                                Approve
                              </Button>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              )} */}

              {tab === 6 ? (
                <TrainingBatchTab
                  trainings={trainings}
                  trainingInitialData={initialData}
                  showFilter={showFilter}
                  setShowFilterBtn={setShowFilterBtn}
                />
              ) : (
                // : tab === 1 ? (
                // <SearchBootstrapTable
                //   data={tableVFLList}
                //   columns={sortableColumn}
                //   // {...(tab === 5 ? { tableToolbarView: tableToolbarView } : [])}
                // />
                //   <AllTrainingBatch data={tableVFLList} columns={sortableColumn} />
                // )
                <>
                  <SelectAllHeader
                    onSelectAll={handleOnSelectAll}
                    onSort={onSortSelection}
                    selectAllRef={selectAllRef}
                    tableContainerRef={tableContainerRef}
                  />
                  {!loading ? (
                    <SearchBootstrapTable
                      searchKey={"scheduleTrainingDesktopSearch"}
                      data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                      columns={sortableColumn}
                      selectRow={selectRow}
                      {...(tab === 5 ? { tableToolbarView: tableToolbarView } : {})}
                      onTableChange={onTableChange}
                      sort={sort}
                      remote={{
                        sort: true,
                      }}
                      tableBeforeSearch={tableToolbarBeforeView}
                      batchButtonView={batchButtonView}
                      tableKey={"scheduleTraining"}
                    />
                  ) : (
                    <NetZeroLoader />
                  )}
                </>
              )}

              <AddToBatchModal
                onChange={onChangeBatch}
                show={showModal}
                onHide={setShowModal}
                form={form}
                error={error}
                onSubmit={onSubmit}
                categoryOption={categoryOption}
                subcategoryOption={subcategoryOption}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

function AddToBatchModal({
  show,
  onHide,
  title = "Create Batch",
  form,
  onChange,
  error,
  onSubmit,
  categoryOption,
  subcategoryOption,
}) {
  const handleClose = () => onHide(false);
  const [area, areaOption] = useArea();

  const TRAINING_TYPE_VIEW_FOR_BATCH = {
    basicTraining: "Basic Training(BT)",
    refreshTraining: "Refresh  Training(RT)",
    newBasicTraining: "New Basic Training(NBT)",
    other: "Other",
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col lg={4}>
              <FormInput
                label={"Training Type"}
                name="trainingType"
                value={TRAINING_TYPE_VIEW_FOR_BATCH[form?.trainingType]}
                onChange={onChange}
                error={error?.trainingType}
                disabled
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Mines Name"}
                name="ehsSiteId"
                value={form?.ehsSiteId}
                onChange={onChange}
                error={error?.ehsSiteId}
                disabled
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Name of Center"}
                name="centerName"
                value={form?.centerName}
                onChange={onChange}
                error={error?.centerName}
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Center Code"}
                name="centerCode"
                value={form?.centerCode}
                onChange={onChange}
                error={error?.centerCode}
              />
            </Col>
            {/* <Col lg={4}>
              <FormSelect
                label={"Area Of Operation"}
                name="areaId"
                value={form?.areaId}
                onChange={onChange}
                options={areaOption}
                error={error?.areaId}
                blankSelect={"Select"}
                menuPortalTarget={null}
              ></FormSelect>
            </Col> */}
            <Col lg={4}>
              <FormInput
                label={"Training ID ( VTO To Provide )"}
                name="trainingId"
                value={form?.trainingId}
                onChange={onChange}
                error={error?.trainingId}
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Batch ID ( VTO To Provide )"}
                name="batchId"
                value={form?.batchId}
                onChange={onChange}
                error={error?.batchId}
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Duration (Days)"}
                name="duration"
                value={form?.duration}
                onChange={onChange}
                error={error?.duration}
              />
            </Col>
            <Col lg={4}>
              <FormDateTimePicker
                value={form.trainingDate}
                name="trainingDate"
                onChangeDate={onChange}
                // timeFormat={"HH:mm:ss"}
                dateFormat="YYYY-MM-DD"
                label={"Date of commencement of training"}
                error={error?.trainingDate}
              />
            </Col>
            <Col lg={4}>
              <FormDateTimePicker
                value={form.endDate}
                name="endDate"
                onChangeDate={onChange}
                // timeFormat={"HH:mm:ss"}
                dateFormat="YYYY-MM-DD"
                label={"End Date Of Training"}
                error={error?.endDate}
              />
            </Col>
            <Col lg={4}>
              <FormInput
                label={"Number Of Days"}
                name="numberOfDays"
                value={form?.numberOfDays}
                onChange={onChange}
                error={error?.numberOfDays}
              />
            </Col>
            <Col lg={4}>
              <FormSelect
                label={"Session"}
                name="session"
                value={form?.session}
                onChange={onChange}
                options={TRAINING_SESSION_OPTION}
                error={error?.session}
                blankSelect={"Select"}
                menuPortalTarget={null}
              ></FormSelect>
            </Col>
            <Col lg={4}>
              <FormSelect
                label={"Schedule"}
                name="schedule"
                value={form?.schedule}
                onChange={onChange}
                options={TRAINING_SCHEDULE_OPTION}
                error={error?.schedule}
                blankSelect={"Select"}
                menuPortalTarget={null}
                disabled
              ></FormSelect>
            </Col>
            <Col lg={4}>
              <FormSelect
                label={"Training Category (Skill Area)"}
                name="trainingCategory"
                value={form?.trainingCategory}
                onChange={onChange}
                options={categoryOption}
                error={error?.trainingCategory}
                blankSelect={"Select"}
                menuPortalTarget={null}
              ></FormSelect>
            </Col>
            <Col lg={4}>
              <FormSelect
                label={"Training Category (Skill Subarea)"}
                name="trainingSubCategory"
                value={form?.trainingSubCategory}
                onChange={onChange}
                options={subcategoryOption}
                error={error?.trainingSubCategory}
                blankSelect={"Select"}
                menuPortalTarget={null}
              ></FormSelect>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick>Understood</Button> */}
          <FormBtn
            className=""
            backBtnTitle={"Close"}
            backOnClick={handleClose}
            onSubmit={onSubmit}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Assign;
